import { render } from "./archiveCheck.vue?vue&type=template&id=40f4d69e&scoped=true"
import script from "./archiveCheck.vue?vue&type=script&lang=js"
export * from "./archiveCheck.vue?vue&type=script&lang=js"

import "./archiveCheck.vue?vue&type=style&index=0&id=40f4d69e&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f4d69e"]])

export default __exports__